<template>
    <v-container>

        <v-card-title>
            <h2>National States</h2>
            <v-spacer></v-spacer>
            <v-text-field v-show="this.$store.state.OBJ_APPLICATION_INIT_LOADED" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>

        <template>
            <v-card v-if="!this.$store.state.OBJ_APPLICATION_INIT_LOADED">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div class="loader"></div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </template>
        <br>
        <div v-show="this.$store.state.OBJ_APPLICATION_INIT_LOADED">
            <v-data-table :headers="HEADERS" :items="STATES" :rows-per-page-items="ROWS_LISTITEMS" :pagination.sync="PAGINATION" v-on:update:pagination="UPDATE_PAGINATION" :search="search" class="elevation-1">
                <template v-slot:items="props">
                    <router-link class="tr" :to="{ name: $store.state.ROUTE_STATE, params: { State: props.item.Abbrev }}">
                        <td class="text-xs-left">{{ props.item.Name }}</td>
                        <td class="text-xs-left">{{ props.item.Abbrev }}</td>
                    </router-link>
                </template>

                <template v-slot:no-data>
                    <v-alert :value="true" color="error" icon="warning">
                        {{this.$store.state.STRING_DATA_NONE}}
                    </v-alert>
                </template>

                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>

            </v-data-table>

            <v-btn class="csvButton_hide" color="secondary" v-on:keyup.enter="EXPORTTOCSV()" v-if="STATES.length">
                <v-icon aria-hidden="true" class="mr-1">text_snippet</v-icon>
                <span @click="EXPORTTOCSV()">Download as CSV</span>
            </v-btn>
        </div>
    </v-container>

</template>

<script>
    window.scrollTo(0, 0);

    export default {

        data() {
            return {

                search: '',
                CSV_HEADERS: ['Name', 'Abbreviation'], //  + this.STRING_CRLF,
                CSV_FILENAME: "Handbook-States",

                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],

                PAGINATION: {
                    rowsPerPage: this.$store.state.ROWS_PER_PAGE
                },

                HEADERS: [{
                    text: 'Name',
                    value: 'Name',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Abbreviation',
                    value: 'Abbrev',
                    align: 'left',
                    sortable: true
                },
                ],
            }
        },

        methods: {
            EXPORTTOCSV() {
                this.$gtag.event('states download csv', {
                    'event_category': 'downloads',
                    'event_label': 'states search csv download',
                    'value': 1
                });
                this.$store.dispatch('GETCSV', { DATA: this.STATES, HEADERS: this.CSV_HEADERS, FILENAME: this.CSV_FILENAME })
            },
            UPDATE_PAGINATION: function (options) {
                this.$gtag.event('states pagination items per page', {
                    'event_category': 'filters',
                    'event_label': `items per page: ${options.rowsPerPage}`,
                    'value': 1
                });
                this.$gtag.event('states pagination page', {
                    'event_category': 'filters',
                    'event_label': `page: ${options.page}`,
                    'value': 1
                });
            }
        },

        computed: {
            STATES() {
                return this.$store.getters.GET_STATES
            }
        },
    }
</script>

<style lang="stylus" scoped>
    .v-progress-circular {
        margin: 1rem
    }

    .text-xs-left {
        cursor: pointer;
    }
</style>
